module.exports = __webpack_public_path__ + "img/3.b6eea4a7.png";